module.exports = __webpack_public_path__ + "static/herov2-880596a4864831797c49516053763e13.jpg";